import { EAgentUserActiveStatus, ERoleDepartmentPermission, IAgentOptionsItem } from '../common';

export interface IPlatformUsersParam {
  /** 身份ID */
  identityId?: number;
  /** 用户ID */
  userId?: number;
  /** 代理商用户姓名 */
  name?: string;
  /** 代理商用户手机号 */
  phone?: string;
  /** 角色 */
  roleId?: string;
  /** 用户状态 */
  enabled?: EAgentUserActiveStatus;
  /** 激活状态 */
  activated?: EAgentUserActiveStatus;
  /** 创建时间（起） */
  createTimeStart?: string;
  /** 创建时间（止） */
  createTimeEnd?: string;
  /** 当前页码（从1开始） */
  page?: number;
  /** 每页显示条数 */
  size?: number;
  /** 部门 */
  deptName?: string;
}

export interface IUsersRoleItem {
  /** 平台用户角色ID */
  roleId?: number;
  /** 平台用户角色名称 */
  roleName?: string;
}

export interface IPlatformUsers {
  /** 身份ID */
  identityId?: number;
  /** 平台用户ID */
  userId?: number;
  /** 平台用户姓名 */
  name?: string;
  /** 平台用户手机号 */
  phone?: string;
  /** 平台用户角色 */
  roles?: IUsersRoleItem[];
  /** 平台用户状态 */
  enabled?: number;
  /** 是否是超级管理员 */
  isAdmin?: number;
  /** 平台激活状态 */
  activated?: EAgentUserActiveStatus;
  /** 创建时间 */
  createTime?: string;
  /** 部门 */
  deptName?: string;
  /** 部门id */
  deptId?: number;
}

export interface IAddPlatformUsers {
  /** 身份用户id */
  identityId?: number;
  /** 代理商用户姓名 */
  name?: string;
  /** 是否是超级管理员 */
  isAdmin?: number;
  /** 代理商用户手机号 */
  phone?: string;
  /** 角色 */
  roleIds?: number[];
  /** 是否校验用户存在	 */
  checked?: boolean;
  /** 部门 */
  deptId?: number;
}

export interface IEditDataPermission {
  /** 身份用户id */
  identityId?: number;
  /** 代理商用户姓名 */
  name?: string;
  /** 代理商用户手机号 */
  phone?: string;
  /** 平台用户角色 */
  roles?: IUsersRoleItem[];
  /** 是否设置为管理员 */
  dataLevel?: boolean;
  /** 管理代理商列表 */
  agentList?: IAgentOptionsItem[];
}

export interface IUpdateDataPermission {
  /** 身份用户id */
  identityId?: number;
 /** 是否设置为管理员 */
 dataLevel?: number;
 /** 管理代理商列表 */
 agents?: number[];
}

export enum EUserAdmin {
  /** 平台管理员 */
  Platform = 0,
  /** 代理商管理员 */
  Agent = 1,
  /** 企业管理员 */
  Company = 2,
  /** 服务商管理员 */
  Server = 3,
}

/** 平台、代理商、企业、服务商 超级管理员列表 */
export const userAdminRole = {
  [EUserAdmin.Platform]: [
    {
      roleId: 1,
      roleName: '超级管理员', 
    },
  ],
  [EUserAdmin.Agent]: [
    {
      roleId: 2,
      roleName: '超级管理员', 
    },
  ],
  [EUserAdmin.Company]: [
    {
      roleId: 3,
      roleName: '超级管理员', 
    },
  ],
  [EUserAdmin.Server]: [
    {
      roleId: 9,
      roleName: '超级管理员', 
    },
  ],
};

export interface IDeptTreeItem {
  /** 部门名称 */
  deptName?: string;
  /** 部门ID */
  id?: number;
  /** 部门等级(0一级 1二级 2三级) */
  deptLevel?: 0 | 1 | 2;
  /** 上级部门ID */
  parentId?: number;
  /** 子部门 */
  children?: IDeptTreeItem[];
}

export interface IDeptTreeItemParams {
  /** 部门ID */
  id?: number;
  /** 部门名称 */
  deptName?: string;
  /** 上级部门ID */
  parentId?: number;
}

export interface IUserRoleParams {
  /** 角色ID */
  roleId: number; 
  /** 菜单ID */
  menuIds: number[]; 
  /** 数据权限 */
  dataPermission: ERoleDepartmentPermission;
  /** 部门ID */
  deptIds: number[];
}